import { palette, typography } from '../utils';
export const list = {
  root: {
    borderRadius: '8px',
    '&.select-menu': {
      color: palette.gray.main,
      '& .Mui-selected': {
        fontWeight: 600,
        color: palette.primary.main,
        backgroundColor: palette.primary.lightest
      },
      '& .MuiListItem-root': {
        fontSize: typography.body2.fontSize,
        '&:hover': {
          backgroundColor: palette.primary.lightest
        }
      }
    }
  }
};